module.exports = __webpack_public_path__ + "img/service-aerolina.4112359b.svg";